/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionPhase } from './oralExamSessionPhase';
import type { OralExamAggregateTimeSlotStateResponseInExamEnteredAt } from './oralExamAggregateTimeSlotStateResponseInExamEnteredAt';
import type { OralExamAggregateTimeSlotStateResponseActiveDropInBookingId } from './oralExamAggregateTimeSlotStateResponseActiveDropInBookingId';
import type { OralExamAggregateTimeSlotStateResponseSupervisorCheckedInAt } from './oralExamAggregateTimeSlotStateResponseSupervisorCheckedInAt';
import type { OralExamAggregateTimeSlotStateResponseSupervisorNoShowAt } from './oralExamAggregateTimeSlotStateResponseSupervisorNoShowAt';
import type { OralExamAggregateTimeSlotStateResponseTechnicalCancelledAt } from './oralExamAggregateTimeSlotStateResponseTechnicalCancelledAt';
import type { OralExamAggregateTimeSlotStateResponseSupervisorBroadcast } from './oralExamAggregateTimeSlotStateResponseSupervisorBroadcast';
import type { OralExamSupervisorEntryResponse } from './oralExamSupervisorEntryResponse';
import type { OralExamAggregateTimeSlotStateResponseBrieferId } from './oralExamAggregateTimeSlotStateResponseBrieferId';
import type { OralExamAggregateTimeSlotStateResponseSlotOwnerId } from './oralExamAggregateTimeSlotStateResponseSlotOwnerId';
import type { OralExamBookingRunSummary } from './oralExamBookingRunSummary';
import type { OralExamAggregateTimeSlotStateResponseStageGate } from './oralExamAggregateTimeSlotStateResponseStageGate';
import type { OralExamAggregateTimeSlotStateResponseEtag } from './oralExamAggregateTimeSlotStateResponseEtag';
import type { OralExamAggregateTimeSlotStateResponseSupervisionAbsence } from './oralExamAggregateTimeSlotStateResponseSupervisionAbsence';

/**
 * Time-slot state with one run summary per registration, for lecturer polling.

Deprecated name, retired 2026-09-22: ``OralExamAggregateCohortStateResponse``.
 */
export interface OralExamAggregateTimeSlotStateResponse {
  sessionPhase: OralExamSessionPhase;
  capacity?: number;
  inExamEnteredAt?: OralExamAggregateTimeSlotStateResponseInExamEnteredAt;
  admittedBookingIds?: string[];
  activeDropInBookingId?: OralExamAggregateTimeSlotStateResponseActiveDropInBookingId;
  supervisorCheckedInAt?: OralExamAggregateTimeSlotStateResponseSupervisorCheckedInAt;
  supervisorNoShowAt?: OralExamAggregateTimeSlotStateResponseSupervisorNoShowAt;
  technicalCancelledAt?: OralExamAggregateTimeSlotStateResponseTechnicalCancelledAt;
  supervisorBroadcast?: OralExamAggregateTimeSlotStateResponseSupervisorBroadcast;
  supervisors?: OralExamSupervisorEntryResponse[];
  brieferId?: OralExamAggregateTimeSlotStateResponseBrieferId;
  slotOwnerId?: OralExamAggregateTimeSlotStateResponseSlotOwnerId;
  bookingRuns?: OralExamBookingRunSummary[];
  stageGate?: OralExamAggregateTimeSlotStateResponseStageGate;
  etag?: OralExamAggregateTimeSlotStateResponseEtag;
  minSupervisors?: number;
  maxUnsupervisedSeconds: number;
  supervisionAbsence?: OralExamAggregateTimeSlotStateResponseSupervisionAbsence;
}
